import React from "react";
import './socialNetworks.scss';
import SvgFacebook from "../../../components/ui/icons/SvgFacebook";
import SvgLinkedin from "../../../components/ui/icons/SvgLinkedin";
import SvgTwitter from "../../../components/ui/icons/SvgTwitter";
import SvgYoutube from "../../../components/ui/icons/SvgYoutube";
import SvgInstagram from "../../../components/ui/icons/SvgInstagram";

const SocialNetworks = () => {
    return (
        <div
            className='socialNetworks'
        >
            <a
                href='https://www.facebook.com/energic.io/'
                target='_blank'
                rel='noopener noreferrer'
                title='Lien vers le Facebook Energic'
                aria-label='Lien vers le Facebook Energic'
            >
                <SvgFacebook />
            </a>
            <a
                href='https://www.linkedin.com/company/energic-io/'
                target='_blank'
                rel='noopener noreferrer'
                title='Lien vers le Linkedin Energic'
                aria-label='Lien vers le Linkedin Energic'
            >
                <SvgLinkedin />
            </a>
            <a
                href='https://twitter.com/Energic_io/'
                target='_blank'
                rel='noopener noreferrer'
                title='Lien vers le Twitter Energic'
                aria-label='Lien vers le Twitter Energic'
            >
                <SvgTwitter />
            </a>
            <a
                href='https://www.youtube.com/channel/UChiHOAdkPyhEnBuShoJaxoA/featured'
                target='_blank'
                rel='noopener noreferrer'
                title='Lien vers le Youtube Energic'
                aria-label='Lien vers le Youtube Energic'
            >
                <SvgYoutube />
            </a>
            <a
                href='https://www.instagram.com/energic.io'
                target='_blank'
                rel='noopener noreferrer'
                title='Lien vers le Instagram Energic'
                aria-label='Lien vers le Instagram Energic'
            >
                <SvgInstagram />
            </a>
        </div>
    );
};

export default SocialNetworks;